import { render, staticRenderFns } from "./Vorabinformation.vue?vue&type=template&id=21373f75&scoped=true&"
import script from "./Vorabinformation.vue?vue&type=script&lang=js&"
export * from "./Vorabinformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21373f75",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAlert,VImg})
